import { Box, CircularProgress, DialogContent, Grid, SvgIcon, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import SearchIcon from '@hapana/shared/web/styles/assets/svgs/search.svg'

import { styles } from './manual-check-in.styles'

const EmptySearch = ({ isLoading }) => {
  const { t } = useTranslation(['checkIn'])

  return (
    <DialogContent>
      {isLoading && (
        <Box sx={styles.loading}>
          <CircularProgress />
        </Box>
      )}
      <Grid container sx={styles.emptyWrapper}>
        <Grid item sx={styles.iconWrapper}>
          <SvgIcon component={SearchIcon} sx={styles.searchIcon} />
        </Grid>
        <Grid item>
          <Typography typography="medium" color="gray.56">
            {t('checkIn:emptySearchResult')}
          </Typography>
        </Grid>
      </Grid>
    </DialogContent>
  )
}

EmptySearch.propTypes = {
  isLoading: PropTypes.bool,
}

EmptySearch.defaultProps = {
  isLoading: false,
}

export default EmptySearch
